"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../Button/Button");
var _ModalModule = _interopRequireDefault(require("./Modal.module.css"));
var _excluded = ["type", "onSuccess", "onCancel", "content"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var staticData = {
  auth: {
    title: 'გთხოვთ გაიაროთ ავტორიზაცია',
    buttons: [{
      label: 'შესვლა',
      type: 1
    }, {
      label: 'გაუქმება',
      type: -1
    }]
  },
  error: {
    title: '',
    content: 'არასწორი პარამეტრები',
    buttons: [{
      label: 'დახურვა',
      type: -1
    }]
  },
  message: {
    title: '',
    content: 'შეტყობინება',
    buttons: [{
      label: 'დახურვა',
      type: -1
    }]
  }
};
var Modal = function Modal(_ref) {
  var type = _ref.type,
    onSuccess = _ref.onSuccess,
    onCancel = _ref.onCancel,
    content = _ref.content,
    props = _objectWithoutProperties(_ref, _excluded);
  var usernameRef = (0, _react.useRef)();
  var passwordRef = (0, _react.useRef)();
  var data = (0, _react.useMemo)(function () {
    var update = _objectSpread({}, staticData);
    switch (type) {
      case 'auth':
        {
          update.auth.content = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
            className: _ModalModule.default.row
          }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
            type: "username",
            ref: usernameRef
          }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
            className: _ModalModule.default.row
          }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
            type: "password",
            ref: passwordRef
          }))));
          break;
        }
      case 'message':
        {
          update.message.content = content;
          break;
        }
    }
    return update;
  }, [type]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, _extends({
    onHide: onCancel,
    contentClassName: (0, _classnames.default)(_ModalModule.default.modal, type === 'message' && _ModalModule.default.message)
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: _ModalModule.default.header,
    closeButton: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Title, null, data[type].title)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: _ModalModule.default.body
  }, data[type].content), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: _ModalModule.default.footer
  }, data[type].buttons.map(function (b, i) {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      key: i,
      size: type === 'message' ? 'lg' : 'sm',
      variant: type === 'message' ? 'secondary' : 'primary',
      onClick: b.type > 0 ? function () {
        return onSuccess({
          username: usernameRef.current.value,
          password: passwordRef.current.value
        });
      } : onCancel
    }, b.label);
  })));
};
exports.Modal = Modal;
Modal.propTypes = {
  show: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['auth', 'error', 'message']),
  centered: _propTypes.default.bool,
  onSuccess: _propTypes.default.func,
  onCancel: _propTypes.default.func
};
Modal.defaultProps = {
  show: true,
  type: 'message',
  centered: true,
  content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", null, "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0"), /*#__PURE__*/_react.default.createElement("p", null, "\u10E8\u10D4\u10E3\u10E4\u10D4\u10E0\u10EE\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10DD\u10D7 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4 \u10D1\u10D0\u10DC\u10D9\u10E1 \u10D3\u10D0 \u10D2\u10D0\u10D0\u10E1\u10EC\u10DD\u10E0\u10DD\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E1\u10D0\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10DD \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0."))
  /*onSuccess: function (username, password) {
    alert(`${username} ${password}`);
  },
  onCancel: function () {
    alert('Cancel');
  },*/
};